<template>
  <NavBarWeb/>

  <div style="text-align: left"></div>
  <div class="sectionKoko" style="background-image: url('../assets/images/company-world.webp')">
    <div class="container">
      <div class="row">
        <div class="col">
          <img src="../assets/images/company-world.webp" style="width: 100%;"/>
        </div>
      </div>
      <div class="row" style="text-align: left">
        <span class="sectionHead mt-5">About</span>
        <div class="sectionBody">Koko is a Buy Now Pay Later payment platform incubated under Daraz and was founded in
          Sri Lanka in 2020. We are passionate about evolving the merchant and consumer shopping experience by providing
          our customers with an easy, interest-free payment plan. Koko will be completely free for customers who pay on
          time – helping people spend responsibly without incurring interest, fees, or extended debt. Koko empowers
          customers to access the things they want and need, while still allowing them to maintain financial wellness
          and control, by splitting payments in three, for both online and in-store purchases.
        </div>
      </div>

    </div>


  </div>
  <div class="" style="background-color: #f3eee7">
    <div class="container">

      <div class="row">
<!--        <div class="col-md-12 col-lg-12 col-xl-3">-->
<!--          <img src="../assets/images/sportsKoko.png" alt="sports"></div>-->
        <div class="col-md-12 col-lg-12 col-xl-12">
          <div class="sectionHead text-left" style="text-align: center ">
            {{ $t("m.aboutHeader") }}
          </div>
          <div class="sectionBody text-left" style="text-align: center ">
            {{ $t("m.aboutBody") }}
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-12 mt-3 text-center">
              <img src="../assets/images/InstantAccess1.png" alt="instant-access"><br/>
              <span class="iconExpHead">{{ $t("m.header4_title1") }}</span><br/>
              <span class="iconExpBody">{{ $t("m.header4_title1_a") }}</span>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12 mt-3 text-center">
              <img src="../assets/images/simpInstallments.png" alt="simple-installments"><br/>
              <span class="iconExpHead">{{ $t("m.header4_title2") }}</span><br/>
              <span class="iconExpBody">{{ $t("m.header4_title2_a") }}</span>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12 mt-3 text-center">
              <img src="../assets/images/debit.webp" alt="debits"><br/>
              <span class="iconExpHead">{{ $t("m.header4_title3") }}</span><br/>
              <span class="iconExpBody">{{ $t("m.header4_title3_a") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FooterWeb/>
</template>

<script>

import NavBarWeb from "../components/NavBarWeb";
import FooterWeb from "../components/FooterWeb";

export default {
  name: "About",
  components: {
    FooterWeb,
    NavBarWeb
  },
  mounted() {
    document.title = "Buy Now Pay Later with Koko";
  },
  created(){
    window.fwSettings={
      'widget_id':80000005144
    };
    !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()

  },
}
</script>

<style scoped>

.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
  text-align: center;
}

.faqHeader {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.faqText {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 30px;
  padding-bottom: 30px;
  padding: 5%;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

.kokoWebButtons {
  background-color: #022078;
  border: 0;
  height: 50px;
  width: 100%;
  font-weight: bolder;
}

.playicon {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}


.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

.stepperBody {
  font-size: 16px;
}
</style>

